import { api } from './index';
import { Methods } from './interfaces';

const getStats = () =>
  api<void, any>({
    method: Methods.GET,
    route: '/docker',
  });

const restart = (server: string) => {
  return api<
    { server: string },
    {
      [key: string]: Date;
    }
  >({
    method: Methods.POST,
    route: '/docker',
    payload: { server },
  });
};

export const dockerApi = { restart, getStats };
